var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGradient(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Outline",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5,498.6c0-27.2,0-54,0-81.1c161.9,0,323.3,0,485.5,0c0,26.8,0,53.7,0,81.1C335.6,498.6,173.9,498.6,11.5,498.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M497.4,323.8c0,15.5,0,30.6,0,46.2c-161.8,0-323.4,0-485.6,0c0-15.2,0-30.4,0-46.2C173.2,323.8,334.8,323.8,497.4,323.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5,278.9c0-11.9,0-23.2,0-35c161.8,0,323.2,0,485.4,0c0,11.4,0,22.9,0,35C335.5,278.9,173.9,278.9,11.5,278.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5,201.1c0-8.1,0-15.8,0-23.8c162.1,0,323.8,0,485.9,0c0,8,0,15.7,0,23.8C335.6,201.1,173.9,201.1,11.5,201.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradient);
export default __webpack_public_path__ + "static/media/gradient.a43caec44959a14c3119f5fc0083a4f2.svg";
export { ForwardRef as ReactComponent };